import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";
const call_customer_historyaApi = factory.get("call_customer_history");

const initialState = {
  data: {
    data: [],
    loading: false,
    total: 0,
    filters: {
      skip: 0,
      take: 25,
      page: 0,
      search: "",
      customer_name: null,
      user_id: null,
      customer_id: null,
      start_date: null,
      end_date: null,
      mobile: null,
      city_id: null,
      type: null,
      channel: null,
    },
    dialog: false,
  },
  customers: {
    data: [],
    loading: false,
    total: 0,
    filters: {
      skip: 0,
      take: 25,
      page: 0,
      search: "",
      subscription_status: "near",
      re_attempt: false,
      city_id: null,
      is_active: null,
      status_start_date: null,
      status_end_date: null,
    },
    dialog: false,
  },
  formModal: {
    dialog: false,
    loading: false,
    form: {
      id: null,
      customer_id: null,
      note: "",
      call_result_id: null,
      call_record_url: "",
      call_record_duration: "",
      call_record_date: "",
      call_record: null,
    },
  },
  customerHistoriesModal: {
    dialog: false,
    customer: null,
    histories: [],
  },
};

const callCustomerHistorySlice = createSlice({
  name: "callCustomerHistory",
  initialState,
  reducers: {
    setData: (state, { payload }) => {
      state.data.data = payload.data;
      state.data.total = payload.total;
      state.data.loading = false;
    },
    setLoading: (state, { payload }) => {
      state[payload].loading = !state[payload].loading;
    },
    setFilters: (state, { payload }) => {
      state.data.filters = {
        ...state.data.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.data.filters = initialState.data.filters;
    },
    setFiltersDialog: (state, { payload }) => {
      state.data.dialog = !state.data.dialog;
    },
    setCustomersData: (state, { payload }) => {
      state.customers.data = payload.data || [];
      state.customers.total = payload.total || 0;
      state.customers.loading = false;

      if (state.customerHistoriesModal.dialog && state.customerHistoriesModal.customer) {
        const found = (payload.data || []).find(
          (c) => c.id === state.customerHistoriesModal.customer.id
        );
        if (found) {
          state.customerHistoriesModal.histories = found.call_customer_histories || [];
          state.customerHistoriesModal.customer = {
            id: found.id,
            full_name: found.full_name,
            mobile: found.mobile,
          };
        }
      }
    },
    setCustomersLoading: (state, { payload }) => {
      state.customers.loading =
        payload !== undefined ? payload : !state.customers.loading;
    },
    setCustomersFilters: (state, { payload }) => {
      state.customers.filters = {
        ...state.customers.filters,
        ...payload,
      };
    },
    resetCustomersFilters: (state) => {
      state.customers.filters = initialState.customers.filters;
    },
    setCustomersFiltersDialog: (state) => {
      state.customers.dialog = !state.customers.dialog;
    },
    setDialog: (state, { payload }) => {
      state.formModal.dialog = !state.formModal.dialog;
      if (payload) {
        state.formModal.form = {
          id: payload.id || null,
          customer_id: payload.customer_id
            ? {
              id: payload.customer_id,
              full_name: payload.customer_name || "",
              mobile: payload.mobile || "",
            }
            : null,
          note: payload.note || "",
          call_result_id: payload.call_result_id
            ? typeof payload.call_result_id === "object"
              ? payload.call_result_id
              : {
                id: payload.call_result_id,
                name: payload.call_result_name || "",
              }
            : null,
          call_record_url: payload.call_record_url || "",
          call_record_duration: payload.call_record_duration || "",
          call_record_date: payload.call_record_date || "",
          call_record: payload.call_record_url || payload.call_record_duration
            ? {
              cdr: payload.call_record_id || "",
              caller: payload.caller || "",
              callee: payload.callee || "",
              duration: payload.call_record_duration || "",
              start: payload.call_record_date || "",
              url: payload.call_record_url || "",
            }
            : null,
        };
      } else {
        state.formModal.form = initialState.formModal.form;
      }
    },
    setFormModalLoading: (state, { payload }) => {
      state.formModal.loading =
        payload !== undefined ? payload : !state.formModal.loading;
    },
    setCustomerHistoriesDialog: (state, { payload }) => {
      state.customerHistoriesModal.dialog =
        !state.customerHistoriesModal.dialog;
      if (payload) {
        state.customerHistoriesModal.customer =
          payload.customer || payload || null;
        state.customerHistoriesModal.histories =
          payload.histories ||
          payload.call_customer_histories ||
          [];
      } else {
        state.customerHistoriesModal.customer = null;
        state.customerHistoriesModal.histories = [];
      }
    },
  },
});

export const {
  setData,
  setLoading,
  setFilters,
  resetFilters,
  setFiltersDialog,
  setCustomersData,
  setCustomersLoading,
  setCustomersFilters,
  resetCustomersFilters,
  setCustomersFiltersDialog,
  setCustomerHistoriesDialog,
  setDialog,
  setFormModalLoading,
} = callCustomerHistorySlice.actions;

export default callCustomerHistorySlice.reducer;

//axios
export const index = () => async (dispatch, getState) => {
  try {
    const filters = getState().callCustomerHistory.data.filters;
    const _filters = {
      ...filters,
      user_id: filters.user_id ? filters.user_id.id : null,
      customer_id: filters.customer_id ? filters.customer_id.id : null,
      city_id: filters.city_id ? filters.city_id.id : null,
    };
    dispatch(setLoading("data"));
    const res = await call_customer_historyaApi.index(_filters);
    dispatch(setData(res.data));
  } catch (err) {
    dispatch(setLoading("data"));
    throw new Error(err);
  }
};
const toExcel = () => async (dispatch, getState) => {
  try {
    const filters = getState().callCustomerHistory.data.filters;
    const _filters = {
      ...filters,
      user_id: filters.user_id ? filters.user_id.id : null,
      customer_id: filters.customer_id ? filters.customer_id.id : null,
      city_id: filters.city_id ? filters.city_id.id : null,
    };
    dispatch(setLoading("data"));
    const res = await call_customer_historyaApi.exportToExcel({
      ..._filters,
      is_excel: 1,
    });
    let url = window.URL.createObjectURL(res.data);
    let a = document.createElement("a");
    a.href = url;
    a.download = "call_customer_history.xlsx";
    a.click();
    dispatch(setLoading("data"));
  } catch (err) {
    dispatch(setLoading("data"));
    throw new Error(err);
  }
};

export const getCustomers = () => async (dispatch, getState) => {
  try {
    const filters = getState().callCustomerHistory.customers.filters;
    const _filters = {
      ...filters,
      city_id: filters.city_id ? filters.city_id.id : null,
      subscription_status: filters.re_attempt
        ? null
        : filters.subscription_status === "all" || !filters.subscription_status
          ? null
          : filters.subscription_status,
      re_attempt: filters.re_attempt ? true : null,
    };
    dispatch(setCustomersLoading(true));
    const res = await call_customer_historyaApi.getCustomers(_filters);
    dispatch(setCustomersData(res.data));
  } catch (err) {
    dispatch(setCustomersLoading(false));
    throw new Error(err);
  }
};

export const create = (data, options = {}) => async (dispatch, getState) => {
  try {
    dispatch(setFormModalLoading(true));
    const payload = {
      customer_id: data.customer_id?.id || data.customer_id,
      note: data.note || null,
      call_result_id: data.call_result_id?.id || data.call_result_id || null,
      call_record_url: data.call_record_url || null,
      call_record_duration: data.call_record_duration || null,
      call_record_date: data.call_record_date || null,
    };
    await call_customer_historyaApi.create(payload);
    dispatch(setFormModalLoading(false));
    dispatch(
      showNotification({
        message: "تم إضافة السجل بنجاح",
        type: "success",
      })
    );
    if (getState().callCustomerHistory.formModal.dialog) {
      dispatch(setDialog());
    }
    dispatch(index());
    await dispatch(getCustomers());
    if (options?.onSuccess) {
      options.onSuccess();
    }
  } catch (err) {
    dispatch(setFormModalLoading(false));
    dispatch(
      showNotification({
        message: err.response?.data?.errors?.[0] || "حدث خطأ أثناء الإضافة",
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const update = (data, options = {}) => async (dispatch, getState) => {
  try {
    dispatch(setFormModalLoading(true));
    const payload = {
      customer_id: data.customer_id?.id || data.customer_id,
      note: data.note || null,
      call_result_id: data.call_result_id?.id || data.call_result_id || null,
      call_record_url: data.call_record_url || null,
      call_record_duration: data.call_record_duration || null,
      call_record_date: data.call_record_date || null,
    };
    await call_customer_historyaApi.update(data.id, payload);
    dispatch(setFormModalLoading(false));
    dispatch(
      showNotification({
        message: "تم تعديل السجل بنجاح",
        type: "success",
      })
    );
    if (getState().callCustomerHistory.formModal.dialog) {
      dispatch(setDialog());
    }
    dispatch(index());
    await dispatch(getCustomers());
    if (options?.onSuccess) {
      options.onSuccess();
    }
  } catch (err) {
    dispatch(setFormModalLoading(false));
    dispatch(
      showNotification({
        message: err.response?.data?.errors?.[0] || "حدث خطأ أثناء التعديل",
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const reAttempt = (customer_id, options = {}) => async (dispatch) => {
  try {
    const res = await call_customer_historyaApi.reAttempt({ customer_id });
    const successMsg =
      res.data?.message ||
      (options?.isRemove
        ? "تمت إزالة المشترك من قائمة معاودة الاتصال بنجاح"
        : "تمت إضافة المشترك إلى قائمة معاودة الاتصال بنجاح");
    dispatch(
      showNotification({
        message: successMsg,
        type: "success",
      })
    );
    await dispatch(getCustomers());
    if (options?.onSuccess) {
      options.onSuccess(res);
    }
    return res;
  } catch (err) {
    dispatch(
      showNotification({
        message:
          err.response?.data?.errors?.[0] ||
          err.response?.data?.message ||
          "حدث خطأ أثناء تعديل حالة معاودة الاتصال",
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const CallCustomerHistory = {
  index,
  toExcel,
  getCustomers,
  create,
  update,
  reAttempt,
};
